const events = {
  addScore: "@@score_correctAnswer",
  minusScore: "@@score_incorrectAnswer",

  leftDoorOpen: "LEFT_DOOR_OPEN",
  rightDoorOpen: "RRIGHT_DOOR_OPEN",

  interviewerLeft: "INTERVIEWER_LEFT"
};

export const CHOOSE_SC = "CHOOSE_SC";
export const CHOOSE_EN = "CHOOSE_EN";
export const CHOOSE_TC = "CHOOSE_TC";
export const NEXT_PROGRESS = "NEXT_PROGRESS";
export const LEFT_EXIT = "LEFT_EXIT";
export const RIGHT_EXIT = "RIGHT_EXIT";
export const LEFT_GO = "LEFT_GO";
export const RIGHT_GO = "RIGHT_GO";
export const QUIT_GAME = "QUIT_GAME";
export const QUIT_GAME2 = "QUIT_GAME2";
export const RESTART_GAME = "RESTART_GAME";

export default events;
